export default "__VITE_ASSET__CwZr5RMa__"